/// <reference types="vite/client" />

/**
 * La configuration de l'app, lue une fois au démarrage depuis les variables VITE_* (fixées au build).
 * Sans configuration Firebase, l'app passe en mode « dev » : l'API locale accepte
 * `Authorization: Dev dev` (voir apps/api/CONTRACT.md).
 */
const env = import.meta.env;

export type FirebaseConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  appId: string;
  storageBucket?: string;
  messagingSenderId?: string;
};

function firebaseConfig(): FirebaseConfig | null {
  const apiKey = env.VITE_FIREBASE_API_KEY as string | undefined;
  const projectId = env.VITE_FIREBASE_PROJECT_ID as string | undefined;
  if (!apiKey || !projectId) return null;
  return {
    apiKey,
    projectId,
    authDomain: (env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined) ?? `${projectId}.firebaseapp.com`,
    appId: (env.VITE_FIREBASE_APP_ID as string | undefined) ?? "",
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET as string | undefined,
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined,
  };
}

/**
 * L'API n'envoie pas d'en-têtes CORS : l'app l'appelle sur sa propre origine. En dev, Vite relaie
 * /v1 et /dev/media vers l'API locale (vite.config.ts) ; en ligne, Firebase Hosting réécrit /v1/**
 * vers le service Cloud Run editit-api (firebase.json). VITE_API_URL force une autre adresse
 * (il faut alors que l'API accepte cette origine).
 */
const apiUrl = ((env.VITE_API_URL as string | undefined) ?? "").replace(/\/$/, "");

export const config = {
  apiUrl,
  firebase: firebaseConfig(),
  googleAuth: env.VITE_GOOGLE_AUTH === "1",
  /** L'adresse à écrire pour tout supprimer (page « Ce qu'on fait de vos vidéos »). */
  contactEmail: (env.VITE_CONTACT_EMAIL as string | undefined) ?? "",
  isDev: !!env.DEV,
};

export const devMode = config.firebase === null;
